export default __webpack_public_path__ + "static/partner1-807b37532ecb74848c6d50c03c6e1455.png";